import Image from "next/image";

import cn from "classnames";

export const TwoColumnImageBenefitsImage = ({
  imageUrl,
  alt,
  isProductDetail,
}: TwoColumnImageBenefitsImageProps) => {
  return (
    <figure
      className={cn("relative aspect-[4/3] w-full overflow-hidden", {
        "order-1 shrink-0 max-lg:rounded-none lg:w-[calc((100%-1.5rem)/2)] lg:rounded-3xl":
          isProductDetail,
        "order-1 rounded-2xl lg:rounded-3xl": !isProductDetail,
      })}>
      <Image
        src={imageUrl}
        alt={alt}
        className="h-full w-full object-cover"
        fill
        sizes={
          isProductDetail
            ? "(max-width: 1024px) 100vw, 42vw"
            : "(max-width: 1024px) 100vw, 50vw"
        }
      />
    </figure>
  );
};

export type TwoColumnImageBenefitsImageProps = {
  imageUrl: string;
  alt: string;
  isProductDetail: boolean;
};
